import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import {
  Table,
  Alert,
  Space,
  Input,
  Card,
  Typography,
} from "antd"
import { FolderOpenOutlined, SearchOutlined } from "@ant-design/icons"
import Breadcrumb from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import {
  addFileGasProject,
  addFileGasProjectSingle,
  addPackageInstaller,
  deleteGasProject,
  getGasProjectFiles,
  getGasProjects,
  getGppByGpId,
  getPackageInstaller,
  prepareForFirstSupervisionStage,
  prepareForMapStage,
  resetGasProjectFlag,
  resetPackage,
  resolvedDefect,
  sendGasProjectToGas,
  stopGasProject,
  submitGasProjectAdmin,
  updateGasProject,
  upsertGasProject,
} from "store/actions"
import { getCurrentUser } from "helpers/service_helper"
import "./gasProject.scss"
import { mobileColumn } from "./MobileColumns"

const Index = props => {
  const { lstGasProjects, lstGasProjectsTotal, matches_sm, loading } = props
  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [page, setPage] = useState(1)
  const [filter, setFilter] = useState("")
  const [expanded, setExpanded] = useState("")

  const handleChangeExpand = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setErrorMessage(null)
      if (props.success === "پرونده با موفقیت به شرکت گاز ارسال گردید")
        window.alert(props.success)
      if (props.error) window.alert(props.error)
      props.onResetGasProjectFlag()
    }, 5000)
    return () => clearTimeout(timer)
  }, [errorMessage, props.success, props.error])

  useEffect(() => {
    props.onGetGasProjects({ searchValue: filter, page: page - 1, pageSize })
  }, [page, pageSize, filter])

  const handleTableChange = (pagination) => {
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>پرونده | واحد گاز</title>
      </MetaTags>

      <div style={{ maxWidth: "100%", padding: "0 16px" }}>
        <Breadcrumb
          title={props.t("gasUnit")}
          breadcrumbItem="پرونده های من"
        />

        <Space direction="vertical" style={{ width: "100%", marginBottom: 16 }} size={8}>
          <Alert
            message="برای تخصیص طراحی فقط پلان معماری بدون هرگونه حاشیه یا جدول در ابعاد طول21سانتیمتر ،عرض 14 سانتیمتر آپلود شود"
            type="error"
            showIcon
            style={{ borderRadius: 8 }}
          />
          <Alert
            message="برای پرونده هایی که با شماره 1403 شروع میشوند پلان-ایزومتریک را مثل سابق با مشخصات کامل و جدول آپلود نمایید"
            type="error"
            showIcon
            style={{ borderRadius: 8 }}
          />
          {errorMessage && (
            <Alert message={errorMessage} type="info" showIcon style={{ borderRadius: 8 }} />
          )}
          {props.error && (
            <Alert message={props.error} type="error" showIcon style={{ borderRadius: 8 }} />
          )}
          {props.success && (
            <Alert message={props.success} type="success" showIcon style={{ borderRadius: 8 }} />
          )}
        </Space>

        <Card
          bordered={false}
          style={{ borderRadius: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}
          title={
            <Space>
              <FolderOpenOutlined style={{ color: "#1890ff" }} />
              <span>پرونده های من</span>
            </Space>
          }
          extra={
            <Input
              allowClear
              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
              placeholder="جستجو..."
              value={filter}
              onChange={e => {
                setPage(1)
                setFilter(e.target.value)
              }}
              style={{ width: 220, borderRadius: 8 }}
            />
          }
        >
          <Table
            rowKey="id"
            dataSource={lstGasProjects}
            loading={loading}
            columns={mobileColumn({
              props,
              setErrorMessage,
              currentUser: getCurrentUser(),
              handleChangeExpand,
              expanded,
              matches_sm,
            })}
            pagination={{
              current: page,
              pageSize,
              total: lstGasProjectsTotal,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
            }}
            onChange={handleTableChange}
            scroll={{ x: true }}
            rowClassName={record => record.isCancel ? "row-canceled" : ""}
            size="middle"
          />
        </Card>
      </div>
    </div>
  )
}

const mapStateToProps = ({ GasProjects, USERs, GasProjectProcesses }) => ({
  lstGasProjects: GasProjects.lstGasProjects,
  lstGasProjectsTotal: GasProjects.lstGasProjectsTotal,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  lstPackageInstaller: GasProjects.lstPackageInstaller,
  currentIdGasProject: GasProjects.currentIdGasProject,
  loading: GasProjects.loading,
  lstGpp: GasProjectProcesses.lstGpp,
  error: GasProjects.error,
  success: GasProjects.success,
  userBalance: USERs.userBalance,
})

const mapDispatchToProps = dispatch => ({
  onUpsertGasProject: gasProject => dispatch(upsertGasProject(gasProject)),
  onGetGasProjects: searchValue => dispatch(getGasProjects(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
  onAddFileGasProjectSingle: attachData =>
    dispatch(addFileGasProjectSingle(attachData)),
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onGetPackageInstaller: company => dispatch(getPackageInstaller(company)),
  onSendGasProjectToGas: fileNumber =>
    dispatch(sendGasProjectToGas(fileNumber)),
  onSubmitGasProjectByAdmin: gasProjectId =>
    dispatch(submitGasProjectAdmin(gasProjectId)),
  onAddPackageInstaller: gasProject =>
    dispatch(addPackageInstaller(gasProject)),
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onDeleteGasProject: gasprojectId => dispatch(deleteGasProject(gasprojectId)),
  onUpdateGasProject: gasProject => dispatch(updateGasProject(gasProject)),
  onResolvedDefect: data => dispatch(resolvedDefect(data)),
  onPrepareForMapStage: data => dispatch(prepareForMapStage(data)),
  onPrepareForFirstSupervisionStage: data =>
    dispatch(prepareForFirstSupervisionStage(data)),
  onStopGasProject: data => dispatch(stopGasProject(data)),
  onResetPackage: gpId => dispatch(resetPackage(gpId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
